import React from "react";
import { Link } from "react-router-dom";
import { Rating } from "./Rating";
// import { useSearch } from "../../store/context/SearchContext";

export const ProductCard = ({ data }) => {
  const {p_id, name, overview, poster, price , rating, best_seller } = data
  // const {addItem} = useSearch()
  console.log("data ProductCard", data)
  return (
    <div className="  m-3 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 min-w-[400px]">
      {/* <button onClick={()=> addItem(data)}>add to cart</button> */}
      <Link to={`/products/${p_id}`} className="relative flex justify-center">
        {best_seller && (
          <span className="absolute top-4 left-2 px-2 bg-orange-500 bg-opacity-90 text-white rounded">
            Best Seller
          </span>
        )}
         {/* <img className="rounded-t-lg  w-auto h-64 object-contain" src={`${process.env.REACT_APP_BACKEND_URL_LOCAL}` + poster.url} alt="" /> */}
         <img className="rounded-t-lg  w-auto h-64 object-contain" src={`${process.env.REACT_APP_BACKEND_URL}` + poster.url} alt="" />
      </Link>
      <div className="p-5">
        <Link to={`/products/${p_id}`}>
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            {name}
          </h5>
        </Link>
        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
         {overview}
        </p>

        <div className="flex items-center my-2">
          <Rating rating={rating} />
        </div>

        <p className="flex justify-between items-center">
          <span className="text-2xl dark:text-gray-200">
            <span>$</span>
            <span>{price}</span>
          </span>
        </p>
      </div>
    </div>
  );
};
